import { useState } from 'react';
import { RxCross2 } from 'react-icons/rx';

interface AddressVerificationModalProps {
    isOpen: boolean;
    onClose: () => void;
    onProceed: () => void;
    address: {
        address_1?: string;
        address_2?: string;
        city?: string;
        state?: any;
        zip_code?: string;
    } | null;
    vendorName?: string;
    ntafId?: string;
}

const AddressVerificationModal: React.FC<AddressVerificationModalProps> = ({
    isOpen,
    onClose,
    onProceed,
    address,
    vendorName,
    ntafId
}) => {
    const [isConfirmed, setIsConfirmed] = useState(false);

    if (!isOpen) {
        return null;
    }

    return (
        <div className='fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50'>
            <div className='relative w-full max-w-xl rounded-lg bg-white shadow-lg'>
                <button
                    className='text-gray-600 hover:text-gray-900 absolute right-4 top-4'
                    onClick={onClose}
                >
                    <RxCross2 />
                </button>
                <div className='p-8'>
                    <h2 className='mb-[30px] text-[22px] font-bold'>
                        Add New Address in MIP
                    </h2>

                    <div className='mb-6'>
                        <p className='mb-4 text-gray-700'>
                            This address has never been used in a paid fund request. Please verify that you have added this address to MIP before proceeding.
                        </p>

                        <div className='mb-4'>
                            <h3 className='font-bold'>Vendor Information:</h3>
                            <p className='text-gray-800'>{vendorName} {ntafId && <span>({ntafId})</span>}</p>
                        </div>

                        <div className='mb-4'>
                            <h3 className='font-bold'>Address:</h3>
                            <p className='text-gray-800'>{address?.address_1}</p>
                            {address?.address_2 && <p className='text-gray-800'>{address?.address_2}</p>}
                            <p className='text-gray-800'>
                                {address?.city}, {address?.state?.abbreviation} {address?.zip_code}
                            </p>
                        </div>
                    </div>

                    <div className='mb-6'>
                        <label className='flex items-center cursor-pointer'>
                            <input
                                type='checkbox'
                                className='form-checkbox h-5 w-5 text-primary'
                                checked={isConfirmed}
                                onChange={() => setIsConfirmed(!isConfirmed)}
                            />
                            <span className='ml-2 text-gray-700'>
                                I confirm this address has been added in MIP.
                            </span>
                        </label>
                    </div>

                    <div className='flex justify-end space-x-4'>
                        <button
                            className='rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:border-[#e6f7f8] hover:bg-[#e6f7f8]'
                            onClick={onClose}
                        >
                            CANCEL
                        </button>
                        <button
                            className={`rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 ${isConfirmed
                                ? 'border-warning bg-warning text-black hover:border-[#e6f7f8] hover:bg-[#e6f7f8]'
                                : 'cursor-not-allowed opacity-50 border-gray-300 bg-gray-300 text-gray-700'
                                }`}
                            onClick={onProceed}
                            disabled={!isConfirmed}
                        >
                            PROCEED
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddressVerificationModal; 